module.exports = __webpack_public_path__ + "img/img-12.0c8d5c1e.png";